import { InputTheme } from "../../Input";
import textStyles from "../../../../theme/foundations/generated/textStyles";
const ComponentStyle = Object.assign(Object.assign({}, InputTheme), { sizes: {
        lg: {
            field: Object.assign(Object.assign({}, textStyles.body.largeDemibold), { height: "12", p: "3", color: "semantic.text.primary", borderRadius: "none", _placeholder: {
                    color: "semantic.icon.secondary",
                } }),
        },
    } });
export default ComponentStyle;
//# sourceMappingURL=NumberInput.default.js.map